import { isExperienceItem, isFlightItem } from 'lib/checkout/checkoutUtils'
import { createSelector } from 'reselect'
import { isMultiCartExperienceSupported, isUserCartSupportedItem } from 'lib/checkout/userCart'
import { hasCheckoutFlightItemsWithEmbeddedInsurance } from 'lib/flights/flightUtils'

export const getUserCartAbandonableItems = createSelector(
  (_: App.State, items: Array<App.Checkout.AnyItem>) => items,
  (state: App.State) => state.experience.experiences,
  (items, experienceOffers) => {
    // Redux userCart is always empty now - XState machine handles deduplication when adding items
    const baseSupportedItems = items.filter(isUserCartSupportedItem)
    if (!baseSupportedItems.length) return []
    return baseSupportedItems.filter(item => {
      if (isExperienceItem(item)) {
        if (item.isAccomBundle || item.accommodationParentItemId) return true
        return isMultiCartExperienceSupported(experienceOffers[item.experienceId], item.isGift)
      }
      if (isFlightItem(item)) {
        return !hasCheckoutFlightItemsWithEmbeddedInsurance([item])
      }
      return true
    })
  },
)
